export const NAME = 'dashboards-campaign-ppzts';
